import { Injectable } from '@angular/core';
import { UserPermission } from '@/core/models/user-permission';

@Injectable({
    providedIn: 'root',
})
export class RoleService {
    public static readonly ADMIN_ROLES = [
        UserPermission.ACTIVITY_READ,
        UserPermission.ACTIVITY_EDIT,
        UserPermission.ACTIVITY_CREATE,
        UserPermission.ACTIVITY_DELETE,
        UserPermission.ACTIVITY_READ_TEAM,
        UserPermission.ACTIVITY_EDIT_TEAM,
        UserPermission.ACTIVITY_CREATE_TEAM,
        UserPermission.ACTIVITY_DELETE_TEAM,
        UserPermission.API_KEY,
        UserPermission.TILE_READ,
        UserPermission.TILE_EDIT,
        UserPermission.TILE_FAV,
        UserPermission.TILE_CREATE,
        UserPermission.TILE_ARCHIVE,
        UserPermission.LAYER_READ,
        UserPermission.LAYER_EDIT,
        UserPermission.LAYER_CREATE,
        UserPermission.REPORT_CREATE,
        UserPermission.TEMPLATE_READ,
        UserPermission.TEMPLATE_EDIT,
        UserPermission.TEMPLATE_CREATE,
        UserPermission.USER_CREATE,
        UserPermission.USER_EDIT,
        UserPermission.USER_READ,
        UserPermission.USER_EDIT_PERMISSION,
        UserPermission.INTERFACE_CONFIG,
        UserPermission.WEBHOOK_CONFIG,
        UserPermission.MANAGE_SUBSCRIPTION,
    ];
    public readonly adminRoles = RoleService.ADMIN_ROLES;
    public static readonly MANAGER_ROLES = [
        UserPermission.ACTIVITY_READ,
        UserPermission.ACTIVITY_EDIT,
        UserPermission.ACTIVITY_CREATE,
        UserPermission.ACTIVITY_DELETE,
        UserPermission.ACTIVITY_READ_TEAM,
        UserPermission.ACTIVITY_EDIT_TEAM,
        UserPermission.ACTIVITY_CREATE_TEAM,
        UserPermission.ACTIVITY_DELETE_TEAM,
        UserPermission.API_KEY,
        UserPermission.TILE_READ,
        UserPermission.TILE_EDIT,
        UserPermission.TILE_FAV,
        UserPermission.TILE_CREATE,
        UserPermission.TILE_ARCHIVE,
        UserPermission.LAYER_READ,
        UserPermission.TEMPLATE_READ,
        UserPermission.USER_READ,
    ];
    public readonly managerRoles = RoleService.MANAGER_ROLES;
    public static readonly USER_ROLES = [
        UserPermission.ACTIVITY_READ,
        UserPermission.ACTIVITY_EDIT,
        UserPermission.ACTIVITY_CREATE,
        UserPermission.ACTIVITY_DELETE,
        UserPermission.API_KEY,
        UserPermission.TILE_READ,
        UserPermission.TILE_FAV,
        UserPermission.LAYER_READ,
        UserPermission.TEMPLATE_READ,
    ];
    public readonly userRoles = RoleService.USER_ROLES;

    constructor() {}
}
